import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
var firebaseConfig = {
  apiKey: "AIzaSyAQupzTiDh3M9TgwZqt-KJ4mL9e-WhJOPk",
  authDomain: "alivedata-cd671.firebaseapp.com",
  databaseURL: "https://alivedata-cd671.firebaseio.com",
  projectId: "alivedata-cd671",
  storageBucket: "alivedata-cd671.appspot.com",
  messagingSenderId: "514469480875",
  appId: "1:514469480875:web:5981ad7127e4fc5d74aaee",
  measurementId: "G-BBGKN2FNE8",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// firebase.firestore().settings({ timestampsInSnapshots: true }); // needs to search this later
//   firebase.analytics();
export default firebase;
